import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
// eslint-disable-next-line no-unused-vars
import i18n from './i18n/i18n';
import configureStore from "./redux/store";
import Chatbot from "./components/chatbot/Chatbot";

const { store, persistor } = configureStore();

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <App />
            <Chatbot />
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);

reportWebVitals();
